/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Decrease_Playback_SpeedInputs */



/**
* | output |
* | --- |
* | "Decrease the playback speed of the player. Playback rates include 0.25x - 16x" |
*
* @param {Shortcut_Keys_Desc_Decrease_Playback_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_decrease_playback_speed = /** @type {((inputs?: Shortcut_Keys_Desc_Decrease_Playback_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Decrease_Playback_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diminuer la vitesse de lecture. Les vitesses vont de 0,25x a 16x")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verringern Sie die Wiedergabegeschwindigkeit des Players. Mögliche Wiedergabegeschwindigkeiten sind 0,25x bis 16x.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ridurre la velocità di riproduzione del lettore. Le velocità di riproduzione includono 0,25x - 16x")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уменьшите скорость воспроизведения проигрывателя. Скорость воспроизведения составляет от 0,25x до 16x.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Disminuir la velocidad de reproducción del reproductor. Las velocidades de reproducción van de 0,25x a 16x.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("降低播放器的播放速度。播放速度范围为 0.25 倍至 16 倍。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレーヤーの再生速度を下げます。再生速度は0.25倍速から16倍速まであります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लेयर की प्लेबैक गति कम करें। प्लेबैक गति 0.25x से 16x तक है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diminua a velocidade de reprodução do aparelho. As taxas de reprodução incluem 0,25x a 16x.")
	return /** @type {LocalizedString} */ ("Decrease the playback speed of the player. Playback rates include 0.25x - 16x")
});